import {graphql, useFragment} from 'react-relay'

import {useAppSelector} from '../../../../../hooks/react-redux'
import {usePermission} from '../../../../../hooks/usePermission'
import {Permission} from '../../../../../types'
import {emptyObject} from '../../../../../utils/empty'
import {getDraft} from '../../EditPipelinePage/EditPipelinePage.selectors'
import {usePipelineId} from '../../hooks/pipeline'
import type {NewVcsRootDto} from '../../services/pipelinesApi.types'
import {getIsGitVcsRoot} from '../../utils/getIsGitVcsRoot'

import type {ConfigurationStorageCanEditFragment$key} from './__generated__/ConfigurationStorageCanEditFragment.graphql'

const pipelineFragment = graphql`
  fragment ConfigurationStorageCanEditFragment on PipelineRest {
    parentProject {
      id
    }
  }
`

export function useCanEditVersionedSettings(
  pipelineKey: ConfigurationStorageCanEditFragment$key | null,
) {
  const {parentProject} = useFragment(pipelineFragment, pipelineKey) ?? {}
  return usePermission(Permission.EDIT_VERSIONED_SETTINGS, parentProject?.id)
}

export function useIsGitRepository() {
  const pipelineId = usePipelineId()
  const mainVcsRoot =
    useAppSelector(state => getDraft(state, pipelineId)?.vcsRoot) ?? (emptyObject as NewVcsRootDto)

  return getIsGitVcsRoot(mainVcsRoot.vcsName)
}
